export const environment = {
  production: false,
  bffBaseUrl: 'https://it-usw2-npe-qa-sarmminam-bff-aas.azurewebsites.net',
  baseFront: 'https://it-usw2-npe-qa-sarmminam-sar-aas.azurewebsites.net',
  clientId: "74b771f4-09a8-413c-9714-30b74e0c0abb",

  accessPolicyPDF: "https://www.bhp.com/-/media/documents/ourapproach/wellbeing/200422_self-care.pdf?la=en",
  urlExampleFileEmployee: "https://docs.google.com/spreadsheets/d/1JVld1hWwBGOZXE8kJC9yjnhJoxg7phlPF2ajnvUACBU/export?format=xlsx&id=1JVld1hWwBGOZXE8kJC9yjnhJoxg7phlPF2ajnvUACBU",
  urlExcelLeaderForm: "https://drive.google.com/uc?id=1rDqFoyS7mMgJqASTx9KVd_5IZnAhAdC9&export=download",
  googleCaptchaProps: {
    key: "6LdZJu8UAAAAAErlAU5Ri7GtbIubtMERmQGqHHv-",
  },
  policyPortal: "https://minamcdv.bhp.com/",
  MaxYeardateAccessForms: 10,
};
